import styled from '@emotion/styled';

/* ── styled components ── */

const Section = styled.section`
	background-color: white;
	flex-direction: column;
	@media (min-width: 768px) {
		display: flex;
		height: 100vh;
	}
`;

const Title = styled.div`
	text-transform: uppercase;
	color: black;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	@media (min-width: 768px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
`;

const ImageContainer = styled.div`
	flex: 1;
	overflow: hidden;
`;

const MapImage = styled.img`
	width: 100%;
	height: calc(50vh);
	object-fit: cover;
	object-position: center;
	@media (min-width: 768px) {
		height: 100%;
	}
`;

/* ── component ── */

export default function MapBlockEta({ street }: { street: string }) {
	return (
		<Section id="map">
			<Title>Location</Title>
			<ImageContainer>
				<MapImage src={street} />
			</ImageContainer>
		</Section>
	);
}
